export async function getMilestones() {
    let offset = 0;
    let limit = 100;
    let page;
    const milestones = [];
    do {
        page = await getMilestonesPage(offset, limit);
        offset += limit;
        milestones.push(...page);
    } while (page.length === limit);
    milestones.sort((a, b) => b.order - a.order);
    return milestones;
}
async function getMilestonesPage(offset, limit) {
    const response = await fetch(`https://mapserver.losrealejos.info/milestones/${offset}/${limit}`);
    if (!response.ok) {
        throw new Error('Ha ocurrido un error al obtener milestones.');
    }
    const { milestones } = await response.json();
    return milestones.map((data) => ({
        id: data.id,
        name: data.name,
        address: data.address,
        order: data.orderBy,
        position: {
            lon: data.lon,
            lat: data.lat,
        }
    }));
}
